"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GUIControllerBase = void 0;
const gs = require("@ivanlog/gs");
const AppControllerBase_1 = require("./AppControllerBase");
const CmpModalDialog_1 = require("../com/CmpModalDialog");
const tmpls_1 = require("../com/tmpls");
class GUIControllerBase extends AppControllerBase_1.AppControllerBase {
    constructor(app) {
        super(app);
        this._lockCounter = 0;
        this._body = gs.q('body').first;
        this._layout = new tmpls_1.LayoutMain();
        this._body.prepend(this._layout);
    }
    startAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this._layout.ctrls.cmpHeader.initAsync();
            this._layout.ctrls.lVersion.text = this._app.version;
        });
    }
    showPage(page) {
        if (this._page)
            this._page.cut();
        this._page = page;
        this._layout.ctrls.pageContainer.append(page);
        page.show();
    }
    hidePage() {
        if (!this._page)
            return;
        this._page.cut();
        this._page = undefined;
    }
    lock() {
        if (this._lockCounter === 0)
            this._container.disable();
        this._lockCounter++;
    }
    unlock() {
        this._lockCounter--;
        if (this._lockCounter === 0)
            this._container.enable();
    }
    lockAction(action) {
        return __awaiter(this, void 0, void 0, function* () {
            this.lock();
            const r = yield action;
            this.unlock();
            return r;
        });
    }
    awaitInLockUIAsync(promise) {
        return __awaiter(this, void 0, void 0, function* () {
            this._layout.ctrls.cmpTxLock.show();
            try {
                const result = yield promise;
                this._layout.ctrls.cmpTxLock.hide();
                return result;
            }
            catch (error) {
                this._layout.ctrls.cmpTxLock.hide();
                throw error;
            }
        });
    }
    dialogOkShowAsync(message, title) {
        return __awaiter(this, void 0, void 0, function* () {
            return CmpModalDialog_1.CmpModalDialog.DialogOk(message, title).showAndWaitAsync();
        });
    }
    dialogOkCreate(message, title) {
        return CmpModalDialog_1.CmpModalDialog.DialogOk(message, title);
    }
}
exports.GUIControllerBase = GUIControllerBase;
//# sourceMappingURL=GUIControllerBase.js.map